import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Header } from "../components/Header";
import { Footer } from "../components/Footer";
import { Home, ChevronRight, Building2, ChevronLeft } from "lucide-react";
import { Card } from "../components/ui/card";
import partnerLogo1 from "../assets/images/7f7af179fbd13c21bcdb94422356bbaa4b876e16.png";
import partnerLogo2 from "../assets/images/0cc5041d52c3f7e1260ee31d8e4e62a903285e36.png";
import partnerLogo3 from "../assets/images/f67e7c209ef8f8bdd21528154b8290840648096b.png";
import partnerLogo4 from "../assets/images/c3c78f6d38fc8937b7cc98b628ce9889b35bf8e4.png";
import partnerLogo5 from "../assets/images/cbc86fdd0f23eed4e63233d9487b76d0f46917ff.png";
import partnerLogo6 from "../assets/images/a00a0fd41b671287e23b87aba3f7aae74bd2ac73.png";
import partnerLogo7 from "../assets/images/e0a6dd58c2f0219fc07a91bcd9ca36a912ab9839.png";
import partnerLogo8 from "../assets/images/6c624a198a8d5a1f1b23afaeb99af1f74722dd3c.png";
import partnerLogo9 from "../assets/images/590b8abd1b17ef38cb257013850a5b226367bda2.png";
import partnerLogo10 from "../assets/images/8222525ea4851595991f22cc893a1b05c0ad2bdd.png";
import partnerLogo11 from "../assets/images/605c1b98d74bafde524387a3d6ea5cf5419304fd.png";
import partnerLogo12 from "../assets/images/49396bd1120d132209dafa64553e7710318380a5.png";
import partnerLogo13 from "../assets/images/partner_logo13.png";
import partnerLogo14 from "../assets/images/partner_logo14.png";
import partnerLogo15 from "../assets/images/partner_logo15.png";
import partnerLogo16 from "../assets/images/partner_logo16.png";
import partnerLogo17 from "../assets/images/partner_logo17.png";
import partnerLogo18 from "../assets/images/partner_logo18.png";
import partnerLogo19 from "../assets/images/partner_logo19.png";
import partnerLogo20 from "../assets/images/partner_logo20.png";
import partnerLogo21 from "../assets/images/partner_logo21.png";
import partnerLogo22 from "../assets/images/partner_logo22.png";
import partnerLogo23 from "../assets/images/partner_logo23.png";
import partnerLogo24 from "../assets/images/partner_logo24.png";
import partnerLogo25 from "../assets/images/partner_logo25.png";
import partnerLogo26 from "../assets/images/partner_logo26.png";
import partnerLogo27 from "../assets/images/partner_logo27.png";
import partnerLogo28 from "../assets/images/partner_logo28.png";
import partnerLogo29 from "../assets/images/partner_logo29.png";
import partnerLogo30 from "../assets/images/partner_logo30.png";
import partnerLogo31 from "../assets/images/partner_logo31.png";
import partnerLogo32 from "../assets/images/partner_logo32.png";
import partnerLogo33 from "../assets/images/partner_logo33.png";
import partnerLogo34 from "../assets/images/partner_logo34.png";

export default function PartnersPage() {
  // 删除第三行的第二和第三张（原index 9和10），剩下27个logo
  // 重新映射：index 0-8保持不变，index 9开始对应原index 11及之后
  const totalLogos = 32; // 34 - 2 = 32（跳过原index 9/10）
  const logosPerPage = 16; // 4行 x 4列
  const totalPages = Math.ceil(totalLogos / logosPerPage);
  const [currentPage, setCurrentPage] = useState(1);

  const getPartnerLogo = (index: number) => {
    // 删除第三行的第二和第三张（原index 9和10，对应partnerLogo10和partnerLogo11）
    // 重新映射：index 0-8保持不变，index 9开始对应原index 11及之后
    const originalIndex = index < 9 ? index : index + 2;
    
    const logoMap: { [key: number]: string } = {
      0: partnerLogo1,
      1: partnerLogo2,
      2: partnerLogo3,
      3: partnerLogo4,
      4: partnerLogo5,
      5: partnerLogo6,
      6: partnerLogo7,
      7: partnerLogo8,
      8: partnerLogo9,
      // 跳过9和10（原partnerLogo10和partnerLogo11）
      11: partnerLogo12,
      12: partnerLogo13,
      13: partnerLogo14,
      14: partnerLogo15,
      15: partnerLogo16,
      16: partnerLogo17,
      17: partnerLogo18,
      18: partnerLogo19,
      19: partnerLogo20,
      20: partnerLogo21,
      21: partnerLogo22,
      22: partnerLogo23,
      23: partnerLogo24,
      24: partnerLogo25,
      25: partnerLogo26,
      26: partnerLogo27,
      27: partnerLogo28,
      28: partnerLogo29,
      29: partnerLogo30,
      30: partnerLogo31,
      31: partnerLogo32,
      32: partnerLogo33,
      33: partnerLogo34,
    };
    
    return logoMap[originalIndex] || partnerLogo1;
  };

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#f8fafc' }}>
      <Header />

      {/* 页面横幅 */}
      <div style={{
        background: 'linear-gradient(135deg, #003c8c 0%, #0050b8 50%, #0066cc 100%)',
        padding: '60px 0',
        position: 'relative',
        overflow: 'hidden'
      }}>
        {/* 装饰元素 */}
        <div style={{
          position: 'absolute',
          top: '-50%',
          right: '-10%',
          width: '500px',
          height: '500px',
          borderRadius: '50%',
          background: 'rgba(255,255,255,0.05)',
        }} />
        <div style={{
          position: 'absolute',
          bottom: '-30%',
          left: '-5%',
          width: '300px',
          height: '300px',
          borderRadius: '50%',
          background: 'rgba(255,255,255,0.03)',
        }} />
        
        <div style={{ width: '80%', margin: '0 auto', position: 'relative', zIndex: 1 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '16px' }}>
            <Building2 style={{ width: '40px', height: '40px', color: '#fbbf24' }} />
            <h1 style={{ 
              fontSize: '36px', 
              fontWeight: 700, 
              color: 'white',
              textShadow: '0 2px 4px rgba(0,0,0,0.2)'
            }}>
              合作单位
            </h1>
          </div>
          <p style={{ fontSize: '16px', color: 'rgba(255,255,255,0.8)' }}>
            服务政企委托客户，助力项目规范实施
          </p>
        </div>
      </div>

      {/* 面包屑导航 */}
      <div style={{ backgroundColor: 'white', borderBottom: '1px solid #e5e7eb', boxShadow: '0 1px 2px rgba(0,0,0,0.03)' }}>
        <div style={{ width: '80%', margin: '0 auto', padding: '16px 0' }}>
          <nav style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '14px' }}>
            <Link to="/" style={{ display: 'flex', alignItems: 'center', gap: '4px', color: '#6b7280', textDecoration: 'none' }}>
              <Home style={{ width: '16px', height: '16px' }} />
              首页
            </Link>
            <ChevronRight style={{ width: '16px', height: '16px', color: '#d1d5db' }} />
            <span style={{ color: '#1a365d', fontWeight: 500 }}>合作单位</span>
          </nav>
        </div>
      </div>

      {/* 主内容区域 */}
      <div style={{ width: '80%', margin: '0 auto', padding: '40px 0' }}>
        <Card className="rounded-2xl overflow-hidden shadow-sm border border-gray-200 bg-white">
          {/* Partners Grid */}
          <div style={{ padding: '48px' }}>
            {/* Desktop: 4 columns, Mobile: 2 columns */}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
              {(() => {
                const startIndex = (currentPage - 1) * logosPerPage;
                const endIndex = Math.min(startIndex + logosPerPage, totalLogos);
                const currentPageLogos = [];
                
                for (let i = startIndex; i < endIndex; i++) {
                  const pageIndex = i - startIndex;
                  currentPageLogos.push(
                    <div
                      key={i}
                      style={{
                        backgroundColor: 'white',
                        borderRadius: '12px',
                        overflow: 'hidden',
                        position: 'relative',
                        padding: '24px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        minHeight: '120px',
                        border: '1px solid #f3f4f6',
                        transition: 'all 0.3s ease'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)';
                        e.currentTarget.style.borderColor = '#e5e7eb';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.boxShadow = 'none';
                        e.currentTarget.style.borderColor = '#f3f4f6';
                      }}
                    >
                      <img
                        src={getPartnerLogo(i)}
                        alt="合作单位"
                        style={{
                          width: '100%',
                          height: 'auto',
                          objectFit: 'contain',
                          maxHeight: '100px'
                        }}
                      />
                      {/* Vertical divider line - Desktop only, show on all items except last in each row */}
                      {((pageIndex + 1) % 4 !== 0) && (
                        <div className="hidden md:block absolute top-0 right-0 w-px h-full bg-gray-300 z-10"></div>
                      )}
                    </div>
                  );
                }
                return currentPageLogos;
              })()}
            </div>
            
            {/* 翻页控件 */}
            {totalPages > 1 && (
              <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '12px',
                marginTop: '40px'
              }}>
                <button
                  onClick={() => setCurrentPage(p => Math.max(1, p - 1))}
                  disabled={currentPage === 1}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '6px',
                    padding: '10px 20px',
                    border: '1px solid #e5e7eb',
                    borderRadius: '8px',
                    backgroundColor: currentPage === 1 ? '#f3f4f6' : 'white',
                    color: currentPage === 1 ? '#9ca3af' : '#374151',
                    fontSize: '14px',
                    cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
                    transition: 'all 0.2s'
                  }}
                >
                  <ChevronLeft style={{ width: '16px', height: '16px' }} />
                  上一页
                </button>
                
                <div style={{ display: 'flex', gap: '8px' }}>
                  {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
                    <button
                      key={page}
                      onClick={() => setCurrentPage(page)}
                      style={{
                        width: '40px',
                        height: '40px',
                        border: 'none',
                        borderRadius: '8px',
                        backgroundColor: page === currentPage ? '#003c8c' : 'white',
                        color: page === currentPage ? 'white' : '#374151',
                        fontSize: '14px',
                        fontWeight: page === currentPage ? 600 : 400,
                        cursor: 'pointer',
                        boxShadow: page === currentPage ? '0 4px 12px rgba(0,60,140,0.3)' : '0 1px 3px rgba(0,0,0,0.1)',
                        transition: 'all 0.2s'
                      }}
                    >
                      {page}
                    </button>
                  ))}
                </div>
                
                <button
                  onClick={() => setCurrentPage(p => Math.min(totalPages, p + 1))}
                  disabled={currentPage === totalPages}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '6px',
                    padding: '10px 20px',
                    border: '1px solid #e5e7eb',
                    borderRadius: '8px',
                    backgroundColor: currentPage === totalPages ? '#f3f4f6' : 'white',
                    color: currentPage === totalPages ? '#9ca3af' : '#374151',
                    fontSize: '14px',
                    cursor: currentPage === totalPages ? 'not-allowed' : 'pointer',
                    transition: 'all 0.2s'
                  }}
                >
                  下一页
                  <ChevronRight style={{ width: '16px', height: '16px' }} />
                </button>
              </div>
            )}
          </div>
        </Card>
        
        {/* 底部说明文字 */}
        <div style={{ 
          textAlign: 'center', 
          marginTop: '32px',
          paddingBottom: '40px'
        }}>
          <p style={{ 
            color: '#9ca3af', 
            fontSize: '14px',
            margin: 0
          }}>
            *以上排名不分先后
          </p>
        </div>
      </div>
      <Footer />
    </div>
  );
}

